import React from "react";

export default function ActivityPagination(props) {
  return (
    <>
      <div
        className={`al-pagination-button left ${
          props.paginationState.currentPage <= 1 ? "" : `active`
        }`}
        onClick={() => {
          props.prevPage(
            props.paginationState.currentPage,
            props.listTotalPage
          );
        }}
      >
        {
          <svg
            width="23"
            height="16"
            viewBox="0 0 23 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M22.5566 8.70711C22.9471 8.31658 22.9471 7.68342 22.5566 7.29289L16.1926 0.928932C15.8021 0.538408 15.1689 0.538408 14.7784 0.928932C14.3879 1.31946 14.3879 1.95262 14.7784 2.34315L20.4353 8L14.7784 13.6569C14.3879 14.0474 14.3879 14.6805 14.7784 15.0711C15.1689 15.4616 15.8021 15.4616 16.1926 15.0711L22.5566 8.70711ZM0.151367 9H21.8495V7H0.151367V9Z"
              fill={
                props.paginationState.currentPage <= 1 ? "#0683854e" : `#068385`
              }
            />
          </svg>
        }
      </div>
      <div className="al-text"> Page </div>
      <div className="al-input">
        <input
          type="text"
          onChange={(evt) => {
            props.onPaginationInputChange(evt.target.value);
          }}
          placeholder={props.paginationState.currentPage}
          id="pageNumber"
        />
      </div>
      <div className="al-text"> of {props.listTotalPage} </div>
      <div
        className={`al-pagination-button right ${
          props.paginationState.currentPage >= props.listTotalPage
            ? ""
            : `active`
        }`}
        onClick={() => {
          props.nextPage(
            props.paginationState.currentPage,
            props.listTotalPage
          );
        }}
      >
        {
          <svg
            width="23"
            height="16"
            viewBox="0 0 23 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M22.5566 8.70711C22.9471 8.31658 22.9471 7.68342 22.5566 7.29289L16.1926 0.928932C15.8021 0.538408 15.1689 0.538408 14.7784 0.928932C14.3879 1.31946 14.3879 1.95262 14.7784 2.34315L20.4353 8L14.7784 13.6569C14.3879 14.0474 14.3879 14.6805 14.7784 15.0711C15.1689 15.4616 15.8021 15.4616 16.1926 15.0711L22.5566 8.70711ZM0.151367 9H21.8495V7H0.151367V9Z"
              fill={
                props.paginationState.currentPage >= props.listTotalPage
                  ? "#0683854e"
                  : `#068385`
              }
            />
          </svg>
        }
      </div>
    </>
  );
}
